export const EventSeverity = {
    information: 1,
    warning: 2,
    alarm: 3,
};

export const eventsInfo = {
    'queuedCommandSent': {
        message: 'reports.events.messages.queued-command-sent',
        severity: EventSeverity.information
    },
    'commandResult': {
        message: 'reports.events.messages.command-result',
        severity: EventSeverity.information
    },
    'deviceFuelDrop': {
        message: 'reports.events.messages.device-fuel-drop',
        severity: EventSeverity.information,
        allowUseInReports: true,
    },
    'deviceFuelIncrease': {
        message: 'reports.events.messages.device-fuel-increase',
        severity: EventSeverity.information
    },
    'maintenance': {
        message: 'reports.events.messages.maintenance',
        severity: EventSeverity.warning,
        allowUseInReports: true,
    },
    'driverChanged': {
        message: 'reports.events.messages.driver-changed',
        severity: EventSeverity.information,
        allowUseInReports: true,
    },
    'deviceOnline': {
        message: 'reports.events.messages.device-online',
        severity: EventSeverity.information
    },
    'deviceOffline': {
        message: 'reports.events.messages.device-offline',
        severity: EventSeverity.information
    },
    'deviceInactive': {
        message: 'reports.events.messages.device-inactive',
        severity: EventSeverity.information
    },
    'deviceMoving': {
        message: 'reports.events.messages.device-moving',
        severity: EventSeverity.information
    },
    'deviceStopped': {
        message: 'reports.events.messages.device-stopped',
        severity: EventSeverity.information
    },
    'deviceOverspeed': {
        message: 'reports.events.messages.device-overspeed',
        severity: EventSeverity.warning,
        allowUseInReports: true,
    },
    'ignitionOn': {
        message: 'reports.events.messages.ignition-on',
        severity: EventSeverity.information,
        allowUseInReports: true,
    },
    'ignitionOff': {
        message: 'reports.events.messages.ignition-off',
        severity: EventSeverity.information,
        allowUseInReports: true,
    },
    'media': {
        message: 'reports.events.messages.media',
        severity: EventSeverity.information,
        allowUseInReports: true,
    },
    'deviceUnknown': {
        message: 'reports.events.messages.deviceUnknown',
        severity: EventSeverity.information
    },
    'geofenceEnter': {
        message: 'reports.events.messages.geofence-enter',
        severity: EventSeverity.information,
        allowUseInReports: true,
    },
    'geofenceExit': {
        message: 'reports.events.messages.geofence-exit',
        severity: EventSeverity.information,
        allowUseInReports: true,
    },
    'alarm': {
        'general': {
            message: 'reports.events.messages.alarm.general',
            severity: EventSeverity.warning,
            allowUseInReports: true,
        },
        'sos': {
            message: 'reports.events.messages.alarm.sos',
            severity: EventSeverity.warning
        },
        'vibration': {
            message: 'reports.events.messages.alarm.vibration',
            severity: EventSeverity.warning
        },
        'movement': {
            message: 'reports.events.messages.alarm.movement',
            severity: EventSeverity.warning
        },
        'lowspeed': {
            message: 'reports.events.messages.alarm.lowspeed',
            severity: EventSeverity.warning
        },
        'overspeed': {
            message: 'reports.events.messages.alarm.overspeed',
            severity: EventSeverity.warning,
            allowUseInReports: true,
        },
        'fallDown': {
            message: 'reports.events.messages.alarm.fallDown',
            severity: EventSeverity.warning
        },
        'lowPower': {
            message: 'reports.events.messages.alarm.lowPower',
            severity: EventSeverity.warning
        },
        'lowBattery': {
            message: 'reports.events.messages.alarm.lowBattery',
            severity: EventSeverity.warning
        },
        'fault': {
            message: 'reports.events.messages.alarm.fault',
            severity: EventSeverity.warning,
            allowUseInReports: true,
        },
        'powerOff': {
            message: 'reports.events.messages.alarm.powerOff',
            severity: EventSeverity.warning
        },
        'powerOn': {
            message: 'reports.events.messages.alarm.power-on',
            severity: EventSeverity.warning
        },
        'door': {
            message: 'reports.events.messages.alarm.door',
            severity: EventSeverity.warning,
            allowUseInReports: true,
        },
        'lock': {
            message: 'reports.events.messages.alarm.lock',
            severity: EventSeverity.warning
        },
        'unlock': {
            message: 'reports.events.messages.alarm.unlock',
            severity: EventSeverity.warning
        },
        'geofence': {
            message: 'reports.events.messages.alarm.geofence',
            severity: EventSeverity.warning
        },
        'geofenceEnter': {
            message: 'reports.events.messages.geofence-enter',
            severity: EventSeverity.information,
            allowUseInReports: true,
        },
        'geofenceExit': {
            message: 'reports.events.messages.geofence-exit',
            severity: EventSeverity.information,
            allowUseInReports: true,
        },
        'gpsAntennaCut': {
            message: 'reports.events.messages.alarm.gps-antenna-cut',
            severity: EventSeverity.warning
        },
        'accident': {
            message: 'reports.events.messages.alarm.accident',
            severity: EventSeverity.warning,
            allowUseInReports: true,
        },
        'tow': {
            message: 'reports.events.messages.alarm.tow',
            severity: EventSeverity.warning,
            allowUseInReports: true,
        },
        'idle': {
            message: 'reports.events.messages.alarm.idle',
            severity: EventSeverity.warning,
            allowUseInReports: true,
        },
        'highRpm': {
            message: 'reports.events.messages.alarm.high-rpm',
            severity: EventSeverity.warning,
            allowUseInReports: true,
        },
        'hardAcceleration': {
            message: 'reports.events.messages.alarm.hard-acceleration',
            severity: EventSeverity.warning,
            allowUseInReports: true,
        },
        'hardBraking': {
            message: 'reports.events.messages.alarm.hard-braking',
            severity: EventSeverity.warning,
            allowUseInReports: true,
        },
        'hardCornering': {
            message: 'reports.events.messages.alarm.hard-cornering',
            severity: EventSeverity.warning,
            allowUseInReports: true,
        },
        'laneChange': {
            message: 'reports.events.messages.alarm.lane-change',
            severity: EventSeverity.warning,
            allowUseInReports: true,
        },
        'fatigueDriving': {
            message: 'reports.events.messages.alarm.fatigue-driving',
            severity: EventSeverity.warning,
            allowUseInReports: true,
        },
        'powerCut': {
            message: 'reports.events.messages.alarm.power-cut',
            severity: EventSeverity.warning,
            allowUseInReports: true,
        },
        'powerRestored': {
            message: 'reports.events.messages.alarm.power-restored',
            severity: EventSeverity.warning
        },
        'jamming': {
            message: 'reports.events.messages.alarm.jamming',
            severity: EventSeverity.warning,
            allowUseInReports: true,
        },
        'temperature': {
            message: 'reports.events.messages.alarm.temperature',
            severity: EventSeverity.warning,
            allowUseInReports: true,
        },
        'parking': {
            message: 'reports.events.messages.alarm.parking',
            severity: EventSeverity.warning
        },
        'bonnet': {
            message: 'reports.events.messages.alarm.bonnet',
            severity: EventSeverity.warning,
            allowUseInReports: true,
            showInAssignableEvents: false,
        },
        'footBrake': {
            message: 'reports.events.messages.alarm.foot-brake',
            severity: EventSeverity.warning,
            allowUseInReports: true,
        },
        'fuelLeak': {
            message: 'reports.events.messages.alarm.fuel-leak',
            severity: EventSeverity.warning
        },
        'tampering': {
            message: 'reports.events.messages.alarm.tampering',
            severity: EventSeverity.warning,
            allowUseInReports: true,
        },
        'removing': {
            message: 'reports.events.messages.alarm.removing',
            severity: EventSeverity.warning,
            allowUseInReports: true,
        },
        'maintenance': {
            message: 'reports.events.messages.maintenance',
            severity: EventSeverity.alarm,
            allowUseInReports: true,
            showInAssignableEvents: false,
        },
        'unknown': {
            message: 'reports.events.messages.unknown-alarm-event-type',
            severity: EventSeverity.warning
        },
    },
    'unknown': {
        message: 'reports.events.messages.unknown-event-type',
        severity: EventSeverity.information
    },
}
